// removed by extract-text-webpack-plugin
module.exports = {"confirmMessage":"styles__confirmMessage___1aO7u","actions":"styles__actions___ObuwZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModalConfirmation/styles.css
// module id = 2890
// module chunks = 0